import script from "./AppTest.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTest.vue?vue&type=script&setup=true&lang=js"

import "./AppTest.vue?vue&type=style&index=0&id=28e19b34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e19b34"]])

export default __exports__